import { render, staticRenderFns } from "./OrdenesCompraDetalle.vue?vue&type=template&id=0698be2c"
import script from "./OrdenesCompraDetalle.vue?vue&type=script&lang=js"
export * from "./OrdenesCompraDetalle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports